// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"06d8d800fd46ba02e63f","293":"1fe28e1adf92e9d0284c"}[chunkId] + ".js";
};